import { useState } from 'react';
import { DynamicObjectInterface } from '../sdk/type';

export const useBulkActionState = () => {
  const [resetTrigger, setResetTrigger] = useState(false);
  const [selectedAction, setSelectedAction] = useState<DynamicObjectInterface | {}>({});

  const clearAll = () => {
    setSelectedAction({});
    setResetTrigger(prev => !prev);
  };

  const handleActionInputChange = (value: DynamicObjectInterface) => {
    setSelectedAction(value);
  };

  return {
    resetTrigger,
    selectedAction,
    setSelectedAction,
    clearAll,
    handleActionInputChange,
  };
};
